module.exports = __webpack_public_path__ + "img/5.55edc4ec.jpg";